module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hc-Ib.3e4f4c11.png";